import { render, staticRenderFns } from "./ResultLabel.vue?vue&type=template&id=8b092e46"
import script from "./ResultLabel.vue?vue&type=script&lang=ts"
export * from "./ResultLabel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports